import { components, OptionProps } from 'react-select'
import { cx } from 'class-variance-authority'
import { PencilSimpleIcon } from '@phosphor-icons/react/dist/ssr/PencilSimple'
import { useTranslations } from 'next-intl'
import { pendingRefDisplayClassName } from '@/components/Grid/utils/refDataDisplay'
import type { EditorOption } from './types'

export type CustomOptionProps = OptionProps<EditorOption, boolean> & {
  userId?: string
  onEditClick?: (event: React.MouseEvent<SVGSVGElement>) => void
}

export const SelectOption = (props: CustomOptionProps) => {
  const t = useTranslations('Property')
  const { userId, onEditClick, ...rest } = props

  const isInReview = props.data.isInReview
  const draftTooltip = isInReview ? t('pending-option-tooltip') : undefined
  const toolbar = useTranslations('Toolbar')

  return (
    <components.Option {...rest}>
      <div className="group flex items-center justify-between gap-2  hover:cursor-pointer">
        <div className="min-w-0">
          <span
            className={cx({
              [pendingRefDisplayClassName]: isInReview,
            })}
            title={draftTooltip}
          >
            {props.data.isReference && !props.data.nameLabel
              ? toolbar('select-reference-name-unavailable')
              : props.label}
          </span>
          {props.data.isReference ? (
            <div className="text-xs text-slate-500">
              {[
                props.data.details,
                props.data.status === 'PENDING'
                  ? toolbar('select-reference-pending')
                  : props.data.status === 'ACCEPTED'
                    ? toolbar('select-reference-accepted')
                    : undefined,
                props.data.nameOptionStatus === 'RETURNED'
                  ? toolbar('select-reference-name-returned')
                  : undefined,
              ]
                .filter(Boolean)
                .join(' · ')}
            </div>
          ) : null}
        </div>
        <div className="-mr-1 flex items-center gap-1">
          {props.data.userID === userId && onEditClick && (
            <PencilSimpleIcon
              className="hidden size-4 rounded text-slate-300 hover:bg-primary-300 hover:shadow-md group-hover:block"
              onClick={onEditClick}
              aria-label="Editer"
            />
          )}
        </div>
      </div>
    </components.Option>
  )
}
